import { useMutation } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';
import { IFlattenServerErrorResponse, IServerErrorResponse } from '../../../../types';
import { flattenServerErrorResponse } from '../../../../helpers/errors.helper';

interface ChangePersonalAddressProps {
  street: string;
  apt: string;
  city: string;
  state: string;
  zip: string;
  customerId: string;
}
export interface ChangePersonalAddressReturn {
  string: string;
}
export const useChangePersonalAddress = (
  onSuccess: (response: ChangePersonalAddressReturn) => void,
  onError: (error: IFlattenServerErrorResponse) => void,
) =>
  useMutation(
    'changePersonalAddress',
    async ({ apt, city, state, street, zip, customerId }: ChangePersonalAddressProps) => {
      const apiLink = `${BASE_URL}/api/v1/user/${customerId}/businessAddressFromRegisterAgent`;
      const { data } = await httpService.post(apiLink, {
        city,
        state,
        line1: street,
        line2: apt,
        postalCode: zip,
        country: 'US',
      });
      return data;
    },
    {
      onSuccess: (data) => onSuccess(data),
      onError: (error: IServerErrorResponse) => {
        onError(flattenServerErrorResponse(error));
      },
    },
  );
